export const EXPIRED_DOCUMENT_LABEL = 'Documento expirado';

export const EXPIRED_DOCUMENT_HINT = 'Guardamos os documentos enviados por 30 dias depois da entrega. Se ainda precisar dele, anexe de novo.';

export const EXPIRED_CORRECTION_DOCUMENT_HINT = 'Documento expirado. Se ele for necessário para a correção, anexe de novo.';

export const EXPIRED_DELIVERABLE_HINT = 'Os arquivos de casos arquivados não ficam guardados.';

export const EXPIRED_AUDIO_HINT = 'O áudio expirou: guardamos os arquivos enviados por 30 dias depois da entrega.';
